import { label } from "./Attributes";

export default function Preview() {
    return (
        <span className="m-3">
            <span className="me-2">{label}</span>
        </span>
    );
}
